/**
 * Brand API
 * Handles brand-related endpoints
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAPI } from "./base-api";
export class BrandAPI extends BaseAPI {
    /**
     * Fetch brands by category ID with purchase earning methods
     */
    fetchBrandsByCategoryId(categoryId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.get(`${this.env.API_URL}brands/earning-methods/purchase/categories/${categoryId}/brands`);
                return result.data || [];
            }
            catch (error) {
                console.error("Error fetching brands by category:", error);
                throw error;
            }
        });
    }
}
